import React, { useState } from 'react';
import { addBookInfo } from '../redux/booking/actions';
import store from '../redux/store';
import MapIco from "../assets/img/icons/Frame.svg";
import GuestIco from "../assets/img/icons/Vector (1).svg";
import TicketIco from "../assets/img/icons/Vector (3).svg";
import '../assets/styles.css';

export default function BookingForm() {
        
    const [state, setState] = useState({
        from: '',
        to: '',
        date: '',
        guests: '',
        ticketclassName: '',
    });
    
    const handleChange = (e) => {
        const { name, value } = e.target;
        setState(prevState => ({
            ...prevState,
            [name]: value
        }));
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if(state.from === '' || state.to === '' || state.date === '' || state.guests === '' || state.ticketclassName === '') {
            alert('All fields are required');
        } else {
            store.dispatch(addBookInfo({
                destinationFrom: state.from,
                destinationTo: state.to,
                date: state.date,
                guests: state.guests,
                class: state.ticketclassName,
              }));
              //console.log(store.getState()); // Log the current state of the store
        }
    }
    

    return (
        //<!-- Input Data -->
        <div className="mt-[160px] mx-4 md:mt-[160px] relative">
            <div className="bg-white rounded-md max-w-6xl w-full mx-auto">
                <form className="first-hero lws-inputform">
                    {/* <!-- From --> */}
                    <div className="des-from">
                        <p>Destination From</p>
                        <div className="flex flex-row">
                            <img src={MapIco} alt="" />
                            <select className="outline-none px-2 py-2 w-full" name="from" onChange={handleChange}  id="lws-from" required>
                                <option value="" hidden>Please Select</option>
                                <option>Dhaka</option>
                                <option>Sylhet</option>
                                <option>Saidpur</option>
                                <option>Cox's Bazar</option>
                            </select>
                        </div>
                    </div>

                    {/* <!-- To --> */}
                    <div className="des-from">
                        <p>Destination To</p>
                        <div className="flex flex-row">
                            <img src={MapIco} alt="" />
                            <select className="outline-none px-2 py-2 w-full" name="to" onChange={handleChange}  id="lws-to" required>
                                <option value="" hidden>Please Select</option>
                                <option>Dhaka</option>
                                <option>Sylhet</option>
                                <option>Saidpur</option>
                                <option>Cox's Bazar</option>
                            </select>
                        </div>
                    </div>

                    {/* <!-- Date --> */}
                    <div className="des-from">
                        <p>Journey Date</p>
                        <input type="date" className="outline-none px-2 py-2 w-full date" onChange={handleChange} name="date" id="lws-date" required />
                    </div>

                    {/* <!-- Guests --> */}
                    <div className="des-from">
                        <p>Guests</p>
                        <div className="flex flex-row">
                            <img src={GuestIco} alt="" />
                            <select className="outline-none px-2 py-2 w-full" name="guests" onChange={handleChange} id="lws-guests" required>
                                <option value="" hidden>Please Select</option>
                                <option value="1">1 Person</option>
                                <option value="2">2 Persons</option>
                                <option value="3">3 Persons</option>
                                <option value="4">4 Persons</option>
                            </select>
                        </div>
                    </div>

                    {/* <!-- className --> */}
                    <div className="des-from !border-r-0">
                        <p>className</p>
                        <div className="flex flex-row">
                            <img src={TicketIco} alt="" />
                            <select className="outline-none px-2 py-2 w-full" name="ticketclassName" onChange={handleChange} id="lws-ticketclassName" required>
                            <option value="" hidden>Please Select</option>
                            <option>Business</option>
                            <option>Economy</option>
                            </select>
                        </div>
                    </div>

                    <button className="addCity" type="submit" onClick={handleSubmit} id="lws-addCity" >
                        <svg width="15px" height="15px" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                        </svg>
                        <span className="text-sm">Book</span>
                    </button>
                </form>
            </div>
        </div>
    )
}
